import { Box, Typography, Link } from '@mui/material';
import React from 'react';
import _ from 'lodash';
import { attachmentBoxStyles, attachmentLinkStyles } from './attachmentStyles';
import { Attachment } from '../../../types/Attachment';
import { getFileTypeIcon, formatSize } from '../../../utility/Attachment';

interface IAttachmentItemProps {
  attachment: Attachment;
  showSize?: boolean;
}

function getTruncatedNameWithExtension(name: string, contentType?: string, maxLength = 10): string {
  const dotIndex = name.lastIndexOf('.');
  let base = name;
  let ext = '';

  if (dotIndex !== -1) {
    base = name.slice(0, dotIndex);
    ext = name.slice(dotIndex);
  } else if (contentType) {
    const fallbackExt = _.last(contentType.split('/'));
    if (fallbackExt) ext = `.${fallbackExt}`;
  }

  const truncatedBase = _.truncate(base, { length: maxLength, omission: '…' });
  return `${truncatedBase}${ext}`;
}

const AttachmentItem: React.FC<IAttachmentItemProps> = ({ attachment, showSize = false }) => (
  <Box sx={attachmentBoxStyles}>
    <Link color="inherit" href={attachment.url} target="_blank" sx={attachmentLinkStyles}>
      {getFileTypeIcon(attachment.content_type)}
      <Typography variant="body2" sx={{ maxWidth: 120 }}>
        {getTruncatedNameWithExtension(attachment.name, attachment.content_type)}
      </Typography>
    </Link>
    {showSize && (
      <Typography variant="body2" sx={{ ml: 1, color: 'text.secondary' }}>
        {formatSize(attachment.size)}
      </Typography>
    )}
  </Box>
);

export default AttachmentItem;
